(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/player-exclusions/assets/javascripts/data/exclusion.js') >= 0) return;  svs.modules.push('/components/accountservices/player-exclusions/assets/javascripts/data/exclusion.js'); 'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function getDependencies() {
  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    return require('./definitions.es6');
  }

  return svs.accountservices.player_exclusions.definitions;
}

var _getDependencies = getDependencies(),
    verticals = _getDependencies.verticals,
    pauseTypes = _getDependencies.pauseTypes;

var Exclusion = function () {
  function Exclusion(_ref) {
    var _ref$needSelfTest = _ref.needSelfTest,
        needSelfTest = _ref$needSelfTest === void 0 ? false : _ref$needSelfTest,
        selfTestExpiry = _ref.selfTestExpiry,
        expiry = _ref.expiry,
        _ref$isExpired = _ref.isExpired,
        isExpired = _ref$isExpired === void 0 ? false : _ref$isExpired,
        type = _ref.type,
        vertical = _ref.vertical;

    _classCallCheck(this, Exclusion);

    this.expiry = expiry;
    this.isExpired = isExpired;
    this.needSelfTest = needSelfTest;
    this.selfTestExpiry = selfTestExpiry;
    this.type = type;
    this.vertical = vertical;
  }

  _createClass(Exclusion, [{
    key: "toString",
    value: function toString() {
      return this.vertical;
    }
  }, {
    key: "is24HourExclusion",
    get: function get() {
      return this.type === pauseTypes.GamingPause24 || this.type === pauseTypes.PauseTwentyFourHours || this.type === pauseTypes.PauseTwentyFourHoursGcs;
    }
  }, {
    key: "gcsVertical",
    get: function get() {
      var gcsVertical;

      switch (this.vertical) {
        case verticals.ALLA:
          gcsVertical = 'All';
          break;

        case verticals.BINGO:
          gcsVertical = 'Bingo';
          break;

        case verticals.CASINO:
          gcsVertical = 'NetCasino';
          break;

        case verticals.POKER:
          gcsVertical = 'Poker';
          break;

        case verticals.SPORT:
          gcsVertical = 'SportsBetting';
          break;

        default:
      }

      return gcsVertical;
    }
  }]);

  return Exclusion;
}();

if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
  module.exports = {
    Exclusion: Exclusion
  };
} else {
  svs.accountservices.player_exclusions.Exclusion = Exclusion;
}
 })(window);